import { memo, useRef } from 'react';
import FloatAnimation, { FloatAnimationVariant } from './FloatAnimation';
import GlowAnimation from './GlowAnimation';

interface IconProps {
  className?: string;
}

function ClearNightIcon({ className }: IconProps) {
  const svgRef = useRef<SVGSVGElement | null>(null);
  return (
    <svg
      ref={svgRef}
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-test="weather-icon-clear-night"
    >
      <g filter="url(#filter0_d_clear_night)">
        <path
          d="M59.0078 33C55.2514 37.6384 53 43.5457 53 49.9795C53 64.8912 65.0883 76.9795 80 76.9795C80.3319 76.9795 80.6622 76.9709 80.9912 76.959C76.0412 83.0709 68.4777 86.9795 60 86.9795C45.0883 86.9795 33 74.8912 33 59.9795C33 45.4 44.5558 33.5221 59.0078 33Z"
          fill="#FFA51F"
        >
          <FloatAnimation
            variant={FloatAnimationVariant.MoonDrift}
            rotate
            rotateAmplitude={7}
            rotateDuration={6}
            rotateCenterX={57}
            rotateCenterY={60}
          />
        </path>
      </g>
      <g filter="url(#filter1_d_clear_night)">
        <path
          d="M76 33L76.8074 35.4549C77.7003 38.1701 79.8299 40.2997 82.5451 41.1926L85 42L82.5451 42.8074C79.8299 43.7003 77.7003 45.8299 76.8074 48.5451L76 51L75.1926 48.5451C74.2997 45.8299 72.1701 43.7003 69.4549 42.8074L67 42L69.4549 41.1926C72.1701 40.2997 74.2997 38.1701 75.1926 35.4549L76 33Z"
          fill="#FFA51F"
        >
          <FloatAnimation variant={FloatAnimationVariant.Downwash} />
        </path>
      </g>
      <g filter="url(#filter2_d_clear_night)">
        <path
          d="M83 58L83.3588 59.0911C83.7557 60.2978 84.7022 61.2443 85.9089 61.6412L87 62L85.9089 62.3588C84.7022 62.7557 83.7557 63.7022 83.3588 64.9089L83 66L82.6412 64.9089C82.2443 63.7022 81.2978 62.7557 80.0911 62.3588L79 62L80.0911 61.6412C81.2978 61.2443 82.2443 60.2978 82.6412 59.0911L83 58Z"
          fill="#FFA51F"
        >
          <FloatAnimation variant={FloatAnimationVariant.Bounce} />
        </path>
      </g>
      <defs>
        <filter
          id="filter0_d_clear_night"
          x="17"
          y="17"
          width="79.9912"
          height="85.9795"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="8">
            <GlowAnimation />
          </feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 0.852175 0 0 0 0 0.63208 0 0 0 0.8 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_clear_night"
          x="56.3333"
          y="22.3333"
          width="39.3333"
          height="39.3333"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="5.33333" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 0.852175 0 0 0 0 0.63208 0 0 0 0.8 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_clear_night"
          x="68.3333"
          y="47.3333"
          width="29.3333"
          height="29.3333"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="5.33333" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 0.852175 0 0 0 0 0.63208 0 0 0 0.8 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default memo(ClearNightIcon);
